import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { patientActions } from '_actions';
import {
    PatientDot,
    EditNoteButton,
    PatientCareCenterButton,
    LoadingIcon,
    StatusWarning,
    StatusCritical
} from '_components'
import messageCenterCommonStyles from 'MessageCenter/Common.module.css'
import styles from './Details.module.css'
import { getDateMDYYYY } from '_helpers';

class ProgressDueDetails extends React.Component {

    getDays() {
        let first = new Date(this.props.message.lastSeen)
        let second = new Date();
        second.setHours(0, 0, 0, 0);
        return Math.round((second - first) / (1000 * 60 * 60 * 24));
    }

    getPocText() {
        let txt = '';

        if (this.props.message.pocVisitsMin !== null && this.props.message.pocVisitsMin !== 0 &&
            this.props.message.pocVisitsMax !== null && this.props.message.pocVisitsMax !== 0) {
            txt += this.props.message.pocVisitsMin;
            txt += ' - ';
            txt += this.props.message.pocVisitsMax;
            txt += ' times';
        } else if (this.props.message.pocVisitsMin !== null && this.props.message.pocVisitsMin !== 0) {
            txt += this.props.message.pocVisitsMin;
            txt += ' time';
            txt += this.props.message.pocVisitsMin > 1 ? 's' : '';
        } else if (this.props.message.pocVisitsMax !== null && this.props.message.pocVisitsMax !== 0) {
            txt += this.props.message.pocVisitsMax;
            txt += ' time';
            txt += this.props.message.pocVisitsMax > 1 ? 's' : '';
        }

        txt += ' per ';
        txt += this.props.message.visitsLabel;
        txt += ' for ';

        if (this.props.message.durationMin !== null && this.props.message.durationMin !== 0 &&
            this.props.message.durationMax !== null && this.props.message.durationMax !== 0) {
            txt += this.props.message.durationMin;
            txt += ' - ';
            txt += this.props.message.durationMax;
        } else if (this.props.message.durationMin !== null && this.props.message.durationMin !== 0) {
            txt += this.props.message.durationMin;
        } else if (this.props.message.durationMax !== null && this.props.message.durationMax !== 0) {
            txt += this.props.message.durationMax;
        }
        txt += ' ' + this.props.message.durationLabel;

        return txt;
    }

    getPocText2() {
        let txt = '';

        let visits = this.props.message.pocVisitsMax ? this.props.message.pocVisitsMax : this.props.message.pocVisitsMin;
        let duration = this.props.message.durationMax ? this.props.message.durationMax : this.props.message.durationMin;

        txt += (visits * duration) + ' visits (' + visits + ' x ' + duration + ') or';


        return txt;
    }

    getPocText3() {
        let txt = '';
        let duration = this.props.message.durationMax ? this.props.message.durationMax : this.props.message.durationMin;
        txt += duration + ' ' + this.props.message.durationLabel + ' (expiring on ' + getDateMDYYYY(this.props.message.pocEndDate) + ')';
        return txt;
    }

    startNote() {
        this.props.openPatientStartNote(this.props.message.ptno, this.props.message.epno, undefined, undefined, 3);
    }


    render() {
        if (this.props.message)
            return (
                <div className={messageCenterCommonStyles.message_center_details_wrapper} >
                    <div className={messageCenterCommonStyles.message_header}>Progress Due: {this.props.message.ptname}</div>
                    <hr className={messageCenterCommonStyles.message_header_separator} />

                    <div className={styles.details_table}>
                        <div className={styles.details_cell} >
                            <div className={styles.labels}>
                                <div>Patient:</div>
                                <div>Admission:</div>
                            </div>
                            <div className={styles.data}>
                                <div className={this.props.message.isFederal ? styles.italic : ''}><span className={styles.patient_dot}><PatientDot id={this.props.message.dot} /></span>{' ' + this.props.message.ptname + ' (SYS#' + this.props.message.ptno + ')'}</div>
                                <div>{this.props.message.admissionDesc + ' - ' + this.props.message.discipline + ' - ' + this.props.message.locationName}</div>
                            </div>
                        </div>
                        <div className={styles.button_wrapper}>
                            <div className={styles.button_div}>
                                {!this.props.isAide &&
                                    <span className={styles.button}><EditNoteButton onClick={() => this.startNote()} title={'Create Progress Note'} /></span>
                                }
                                <span className={styles.button}><PatientCareCenterButton ptno={this.props.message.ptno} /></span>
                            </div>
                        </div>
                    </div>

                    <div className={styles.wrapper}>

                        <div className={styles.header}>Payer/Contract Guidelines</div>
                        <div className={styles.sentence}>Based on the admission's payer/contract, a progress note is required:</div>
                        <div className={styles.details_row}>
                            <span className={styles.col1}></span>
                            <span className={styles.col2}>{this.props.pnVisitsThreshold.WTGUIDELINE}</span>
                            <span className={styles.col3}>visits</span>
                        </div>
                        <div className={styles.details_row}>
                            <span className={styles.col1}></span>
                            <span className={styles.col2}>{this.props.pnDaysThreshold.WTGUIDELINE}</span>
                            <span className={styles.col3}>days</span>
                        </div>
                        <div className={styles.sentence}>{'Progress was last documented on ' + getDateMDYYYY(this.props.message.pnDate) + '.  It has been:'}</div>
                        <div className={styles.details_row}>
                            <span className={styles.col1}>
                                {this.props.message.pnVisits >= this.props.pnVisitsThreshold.WTWARNING &&
                                    this.props.message.pnVisits < this.props.pnVisitsThreshold.WTCRITICAL &&
                                    <StatusWarning size='extra-small' />
                                }
                                {this.props.message.pnVisits >= this.props.pnVisitsThreshold.WTCRITICAL &&
                                    <StatusCritical size='extra-small' />
                                }
                            </span>
                            <span className={this.props.message.pnVisits >= this.props.pnVisitsThreshold.WTCRITICAL ? styles.col2_critical : styles.col2}>{this.props.message.pnVisits}</span>
                            <span className={styles.col3}>{this.props.message.pnVisits === 1 ? 'visit' : 'visits'}</span>
                        </div>
                        <div className={styles.details_row}>
                            <span className={styles.col1}>
                                {this.props.message.pnDays >= this.props.pnDaysThreshold.WTWARNING &&
                                    this.props.message.pnDays < this.props.pnDaysThreshold.WTCRITICAL &&
                                    <StatusWarning size='extra-small' />
                                }
                                {this.props.message.pnDays >= this.props.pnDaysThreshold.WTCRITICAL &&
                                    <StatusCritical size='extra-small' />
                                }
                            </span>
                            <span className={this.props.message.pnDays >= this.props.pnDaysThreshold.WTCRITICAL ? styles.col2_critical : styles.col2}>{this.props.message.pnDays}</span>
                            <span className={styles.col3}>{this.props.message.pnDays === 1 ? 'day' : 'days'}</span>
                        </div>




                        <div className={styles.header}>Plan of Care</div>
                        <div className={styles.sentence}>{'The most recent Plan of Care specified on' + getDateMDYYYY(this.props.message.pocStartDate) + ' for this admission indicated:'} </div>
                        <div className={styles.sentence_indent}>
                            {this.getPocText()}
                        </div>
                        <div className={styles.sentence}>This would result in:</div>
                        <div className={styles.sentence_indent}>
                            {this.getPocText2()}
                        </div>
                        <div className={styles.sentence_indent}>
                            {this.getPocText3()}
                        </div>
                        <div className={styles.sentence}>It has been:</div>
                        <div className={styles.details_row}>
                            <span className={styles.col1}>
                                {(this.props.message.pocVisits - this.props.message.actualVisits) <= this.props.pocVisitsRemainThreshold.WTWARNING &&
                                    (this.props.message.pocVisits - this.props.message.actualVisits) > this.props.pocVisitsRemainThreshold.WTCRITICAL &&
                                    <StatusWarning size='extra-small' />
                                }
                                {(this.props.message.pocVisits - this.props.message.actualVisits) <= this.props.pocVisitsRemainThreshold.WTCRITICAL &&
                                    <StatusCritical size='extra-small' />
                                }
                            </span>
                            <span className={(this.props.message.pocVisits - this.props.message.actualVisits) <= this.props.pocVisitsRemainThreshold.WTCRITICAL ? styles.col2_critical : styles.col2}>{this.props.message.actualVisits}</span>
                            <span className={styles.col3}>{this.props.message.actualVisits === 1 ? 'visit' : 'visits'}</span>
                        </div>
                        <div className={styles.details_row}>
                            <span className={styles.col1}>
                                {this.props.pocDaysRemaining <= this.props.pocDaysRemainThreshold.WTWARNING &&
                                    this.props.pocDaysRemaining > this.props.pocDaysRemainThreshold.WTCRITICAL &&
                                    <StatusWarning size='extra-small' />
                                }
                                {this.props.pocDaysRemaining <= this.props.pocDaysRemainThreshold.WTCRITICAL &&
                                    <StatusCritical size='extra-small' />
                                }
                            </span>
                            <span className={this.props.pocDaysRemaining <= this.props.pocDaysRemainThreshold.WTCRITICAL ? styles.col2_critical : styles.col2}>{Math.floor(this.props.pocDays / this.props.message.durationUnit)}</span>
                            <span className={styles.col3}>{this.props.message.durationLabel}</span>
                        </div>
                    </div>



                </div >
            );
        else
            return (
                <div className={messageCenterCommonStyles.message_center_details_wrapper} >
                    <div className={messageCenterCommonStyles.message_header}>Progress Due</div>
                    <hr className={messageCenterCommonStyles.message_header_separator} />
                    {this.props.loading === true ?
                        <LoadingIcon size="small" />
                        : <div className={styles.italic}>No Message Selected</div>
                    }
                </div >
            );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        openPatientStartNote: bindActionCreators(patientActions.openStartNote, dispatch)
    };
}

function mapStateToProps(state) {
    let message = state.entities.pnDueDetails.epno ? state.entities.pnDueDetails : undefined;

    let pnVisitsThreshold = message ?
        state.entities.masterData.PTMASTERTHRESHOLDS[
        Object.keys(state.entities.masterData.PTMASTERTHRESHOLDS)
            .find(key => state.entities.masterData.PTMASTERTHRESHOLDS[key].WTNAME === (message.isWorkComp ? 'PN_DUE_WC_VISITS' : 'PN_DUE_VISITS'))]
        : undefined;

    let pnDaysThreshold = message ?
        state.entities.masterData.PTMASTERTHRESHOLDS[
        Object.keys(state.entities.masterData.PTMASTERTHRESHOLDS)
            .find(key => state.entities.masterData.PTMASTERTHRESHOLDS[key].WTNAME === (message.isWorkComp ? 'PN_DUE_WC_DAYS' : 'PN_DUE_DAYS'))]
        : undefined;

    let pocVisitsRemainThreshold = message ?
        state.entities.masterData.PTMASTERTHRESHOLDS[
        Object.keys(state.entities.masterData.PTMASTERTHRESHOLDS)
            .find(key => state.entities.masterData.PTMASTERTHRESHOLDS[key].WTNAME === 'POC_VISITS_REMAINING')]
        : undefined;

    let pocDaysRemainThreshold = message ?
        state.entities.masterData.PTMASTERTHRESHOLDS[
        Object.keys(state.entities.masterData.PTMASTERTHRESHOLDS)
            .find(key => state.entities.masterData.PTMASTERTHRESHOLDS[key].WTNAME === 'POC_DAYS_TO_EXPIRATION')]
        : undefined;

    let today = new Date();
    today.setHours(0, 0, 0, 0);
    let pocDaysRemaining = message && message.pocEndDate ? Math.round((new Date(message.pocEndDate) - today) / (1000 * 60 * 60 * 24)) : 0;

    let pocDays = message && message.pocStartDate ? Math.round((today - new Date(message.pocStartDate)) / (1000 * 60 * 60 * 24)) : 0;
    let isAide = state.entities.authentication.user.isAide;

    return {
        message,
        isAide,
        loading: state.ui.pnDue.detailsLoading,
        pnVisitsThreshold,
        pnDaysThreshold,
        pocVisitsRemainThreshold,
        pocDaysRemainThreshold,
        pocDaysRemaining,
        pocDays
    };
}


const connectedProgressDueDetails = connect(mapStateToProps, mapDispatchToProps)(ProgressDueDetails);
export { connectedProgressDueDetails as ProgressDueDetails };
